const cmt400Router = [
  {
    path: "cmt",
    name: "cmt",
    component: (resolve) => require(["@views/questions/400-Comment"], resolve),
    meta: {
      title: "400服务评价",
      skipWxAuth: true, // 跳过微信授权
    },
  },
];

export default cmt400Router;



// WEBPACK FOOTER //
// ./src/router/400/index.js